import script from "./SignatureInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./SignatureInputComponent.vue?vue&type=style&index=0&id=92a9451a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92a9451a"]])

export default __exports__